import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ICON_PATH_COUNTRIES } from '@app/utils/constants/countries.constants';
import { ICON_PATH } from '@app/utils/constants/icon-map.constants';
import { CountriesEnumList } from '@app/utils/enums/countries.enum';
import { IconName } from '@app/utils/enums/icon-enum';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  public icon = input.required<IconName | CountriesEnumList>();
  public iconPath = computed(() => {
    const iconValue = this.icon();
    return (
      ICON_PATH[iconValue as IconName] || ICON_PATH_COUNTRIES[iconValue as CountriesEnumList] || ''
    );
  });
}
